import React, { useEffect, useState, useCallback } from 'react';
import Dropdown from 'components/Input/dropdown/Dropdown';
import Toolbar from 'components/Toolbar';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NormalizerChannel } from 'models/normalizer';
import actions from 'state/actions';
import utils from 'utils';

interface DropDownRouteOptions {
  label: string;
  value: string;
}

interface DropDownTabOptions {
  label: string;
  value: NormalizerChannel;
}

const ToolBar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();
  const t = utils.intl.useTranslator();

  const routes: DropDownRouteOptions[] = [
    { label: t('Dashboard'), value: 'dashboard' },
    { label: t('Monitor'), value: 'monitor' },
    { label: t('Error'), value: 'error' },
    { label: t('Timers'), value: 'timers' },
    { label: t('Pending'), value: 'pending' },
  ];

  const tabs: { [key: string]: DropDownTabOptions[] } = {
    dashboard: [
      { label: t('Disk'), value: 'disk' },
      { label: t('Mail'), value: 'mail' },
    ],
    monitor: [
      { label: t('Disk'), value: 'disk' },
      { label: t('Mail'), value: 'mail' },
      { label: t('Upload'), value: 'upload' },
      { label: t('Einvoice'), value: 'eInvoice' },
    ],
    error: [],
    timers: [],
    pending: [],
  };

  const [activeRouteOption, setActiveRouteOption] = useState<DropDownRouteOptions>(routes[0]);
  const [tabOptions, setTabOptions] = useState<DropDownTabOptions[]>(tabs[activeRouteOption.value]);
  const [activeTab, setActiveTab] = useState(tabs.dashboard[0]);

  const onRoutesDropDownChange = useCallback(
    (option: DropDownRouteOptions) => {
      setActiveRouteOption(option);
      if (option.value === 'dashboard') {
        history.push(`${path}`);
      } else {
        history.push(`${path}/${option.value}`);
      }
    },
    [history, path],
  );

  const setDefaultRoute = () => {
    // set default route onMount
    onRoutesDropDownChange(routes[0]);
  };

  const stableSetDefaultRoute = useCallback(setDefaultRoute, [onRoutesDropDownChange, routes[0].label]);

  useEffect(() => {
    stableSetDefaultRoute();
  }, [stableSetDefaultRoute]);

  const onTabsDropDownChange = (option: DropDownTabOptions) => {
    setActiveTab(option);
    if (activeRouteOption.value === 'monitor') {
      dispatch(actions.normalizer.setSelectedMonitorRow([]));
    }
  };

  const compareActiveOption = () => {
    const urlActiveOption = history.location.pathname.substring(path.length + 1);

    if (urlActiveOption === activeRouteOption.value) return;
    if (urlActiveOption === '') {
      setActiveRouteOption(routes[0]);
    } else {
      const findOption = routes.find((el) => el.value === urlActiveOption);
      if (findOption) setActiveRouteOption(findOption);
    }
  };

  const setTabs = () => {
    setTabOptions(tabs[activeRouteOption.value]);
    setActiveTab(tabs[activeRouteOption.value][0]);
  };

  const stableSetTabs = useCallback(setTabs, [activeRouteOption]);
  const stableCompareActiveOption = useCallback(compareActiveOption, [history.location.pathname]);

  useEffect(() => {
    stableSetTabs();
  }, [stableSetTabs]);

  useEffect(() => {
    stableCompareActiveOption();
  }, [stableCompareActiveOption]);

  useEffect(() => {
    activeTab && dispatch(actions.normalizer.setTab(activeTab.value));
  }, [activeTab, dispatch]);

  return (
    <Toolbar.BlueBar>
      <Toolbar.Left>
        <Toolbar.DropContainer>
          <Dropdown id="routes-dropdown" onChange={onRoutesDropDownChange} options={routes} value={activeRouteOption} />
        </Toolbar.DropContainer>
        {tabOptions.length ? (
          <Toolbar.DropContainer>
            <Dropdown id="tabs-dropdown" onChange={onTabsDropDownChange} options={tabOptions} value={activeTab} />
          </Toolbar.DropContainer>
        ) : null}
      </Toolbar.Left>
      <Toolbar.Right>
        <Toolbar.ModuleName>Monitor</Toolbar.ModuleName>
      </Toolbar.Right>
    </Toolbar.BlueBar>
  );
};

export default ToolBar;
